import { render, staticRenderFns } from "./SettingsWhatsApp.vue?vue&type=template&id=7260ca0b&scoped=true"
import script from "./SettingsWhatsApp.vue?vue&type=script&lang=js"
export * from "./SettingsWhatsApp.vue?vue&type=script&lang=js"
import style0 from "./SettingsWhatsApp.vue?vue&type=style&index=0&id=7260ca0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7260ca0b",
  null
  
)

export default component.exports